import { ServerProductCard } from 'product-card/components/server/ServerProductCard'
import { ProductLocations } from 'product/types/ProductLocations'
import React from 'react'

import {
	inspProductCard,
	inspProductCardIdx,
} from '../../constants/datatestIds'
import type { InspirationalProductCardProps } from '../../types/InspirationalProductCard'
import { Cell } from '../Cell/Cell'

export const InspirationalServerProductCard = ({
	product,
	isTwoColumnSize,
	index,
}: InspirationalProductCardProps) => {
	const { colorId } = product
	return (
		<Cell productId={product.id} colorId={colorId}>
			<ServerProductCard
				imageSortCriteria={product.images.order}
				productId={product.id}
				colorId={colorId}
				lookId={product.lookId ?? '99'}
				location={ProductLocations.Grid}
				isTwoColumnSize={isTwoColumnSize}
				dataTestId={
					index !== undefined ? inspProductCardIdx(index) : inspProductCard
				}
			/>
		</Cell>
	)
}
